import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=52d770c3&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=ts"
export * from "./AppBar.vue?vue&type=script&lang=ts"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=52d770c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d770c3",
  null
  
)

export default component.exports